const Bag = function(quality) {
  const size = Math.round(
    4 + quality * 25 + Math.random() * 3,
  );
  const items = [];
  for (let i = 0; i < size; ++i) {
    items[i] = { value: null };
  }

  return {
    slot: 'item_container',
    type: 'bag',
    quality: quality,
    size,
    items,
  };
};
module.exports = Bag;
